import React, { useState, Fragment } from 'react';
import { Button } from 'react-admin';
import { useTranslate } from 'ra-core';

import LockWalletsDialog from './LockWalletsDialog';

const LockWalletsButton = () => {
	const [open, setOpen] = useState(false);
	const translate = useTranslate();

	const handleClick = () => {
		setOpen(true);
	};

	const handleDialogClose = () => {
		setOpen(false);
	};

	const handleConfirm = () => {
		// const { basePath, crudUpdateMany, resource, selectedIds } = this.props;
		// TODO crudUpdateMany(resource, selectedIds, { views: 0 }, basePath);
		setOpen(true);
	};

	return (
		<Fragment>
			<Button
				label={translate('coreWalletAdmin.wallets.list.lockDialog.title')}
				onClick={handleClick}
			/>
			<LockWalletsDialog
				open={open}
				onClose={handleDialogClose}
				onConfirm={handleConfirm}
			/>
		</Fragment>
	);
};

export default LockWalletsButton;
